<section class="my-5 container-lg">
  <div class="alert alert-danger">
    <h5>
      <i class="me-2 fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <span>Неуспешно плащане</span>
    </h5>
    <hr/>
    <p class="m-0">
      Ако имате въпроси или нужда от допълнителна информация, не се колебайте да се свържете с нас.
    </p>
  </div>
</section>
